import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

import { Button, Row, Col, Skeleton, Divider } from 'antd';
import { styled } from '@xstyled/styled-components';
import { getSize, styleVariables } from '@lib/common';
import { QuestionReleases, QuestionType } from '@module/form';
import { useEffect, useMemo, useState } from 'react';
import { SoundFilled } from '@ant-design/icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var SectionPanel = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 15px;\n  background: transparent;\n  cursor: ", ";\n"])), function (props) {
  return props.$isSelected ? 'default' : 'pointer';
});
var StyledSectionTitle = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: ", ";\n"])), getSize('padding8'));
var AnswerProcess = styled.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n\n  font-size: fontSizeSmall;\n  margin-bottom: 0;\n"])), styleVariables.colors.gray10);
var PanelContent = styled(Row)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var QuestionItemColumn = styled(Col)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral([""])));
var QuestionItem = styled(Button)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  width: 44px;\n  height: 40px;\n  margin-right: ", ";\n  margin-bottom: ", ";\n  border: ", ";\n\n  border-radius: ", ";\n\n  color: ", ";\n  background-color: ", ";\n"])), getSize('padding8'), getSize('padding8'), function (props) {
  return !props.answered ? "1px solid ".concat(styleVariables.colors.gray7) : "1px solid ".concat(styleVariables.colors.blue3);
}, getSize('padding8'), function (props) {
  return props.answered ? styleVariables.colors.blue3 : styleVariables.colors.gray11;
}, function (props) {
  return props.answered ? styleVariables.colors.blue1 : styleVariables.colors.gray1;
});
var StyledSectionHeader = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
var StyledSoundFilled = styled(SoundFilled)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-size: 18px;\n  cursor: pointer;\n  margin-left: ", ";\n"])), getSize('padding20'));
var StyledDivider = styled(Divider)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  margin: ", " 0;\n"])), getSize('padding16'));
export var SubmissionSectionSummaryV2 = function SubmissionSectionSummaryV2(props) {
  var label = props.label,
      sectionSummaries = props.sectionSummaries,
      onSelectQuestion = props.onSelectQuestion,
      questionReleases = props.questionReleases,
      answeredQuestionIds = props.answeredQuestionIds,
      readonly = props.readonly,
      selectedSectionIndex = props.selectedSectionIndex,
      isLoadingGetQuestions = props.isLoadingGetQuestions,
      currentPlayingAudioId = props.currentPlayingAudioId; // Local states

  var _useState = useState(selectedSectionIndex),
      activeKey = _useState[0],
      setActiveKey = _useState[1];

  var continuousQuestionIndexes = useMemo(function () {
    return QuestionReleases.getContinuousQuestionIndexes(questionReleases || [], sectionSummaries);
  }, [questionReleases, sectionSummaries]);

  var getQuestionDisplayIndex = function getQuestionDisplayIndex(question) {
    var _ref, _continuousQuestionIn;

    return (_ref = (_continuousQuestionIn = continuousQuestionIndexes.get(question.id.toString())) !== null && _continuousQuestionIn !== void 0 ? _continuousQuestionIn : question.index) !== null && _ref !== void 0 ? _ref : 1;
  }; // Callbacks


  var getTotalQuestions = function getTotalQuestions(questions, section) {
    var _questions$filter;

    var total = 0;
    (questions === null || questions === void 0 ? void 0 : questions.length) > 0 && ((_questions$filter = questions.filter(function (q) {
      return q.sectionId === section.id.toString();
    })) === null || _questions$filter === void 0 ? void 0 : _questions$filter.forEach(function (q) {
      switch (q.type) {
        case QuestionType.FillInBlank:
          return total = total + q.answers.length;

        case QuestionType.Matching:
          var matchingQuestion = q;
          return total = total + matchingQuestion.subQuestions.length;

        default:
          return total = total + 1;
      }
    }));
    return total;
  };

  var getNumberQuestionAnswered = function getNumberQuestionAnswered(section) {
    var numberQuestionAnswered;

    if (readonly) {
      numberQuestionAnswered = 0;
    } else {
      numberQuestionAnswered = answeredQuestionIds === null || answeredQuestionIds === void 0 ? void 0 : answeredQuestionIds.filter(function (questionAnswered) {
        var sectionId = questionAnswered.split('_')[2];
        return sectionId === section.id.toString();
      }).length;
    }

    return numberQuestionAnswered || 0;
  }; // Effects


  useEffect(function () {
    setActiveKey(selectedSectionIndex);
  }, [selectedSectionIndex]); // Render UI

  var renderQuestionItems = function renderQuestionItems(section, index) {
    if (isLoadingGetQuestions) {
      return /*#__PURE__*/_jsx(Skeleton, {
        active: true
      });
    }

    var matchingQuestionReleases = questionReleases === null || questionReleases === void 0 ? void 0 : questionReleases.filter(function (q) {
      return (q === null || q === void 0 ? void 0 : q.sectionId) === section.id.toString();
    }).slice().sort(function (a, b) {
      var _ref2, _continuousQuestionIn2, _ref3, _continuousQuestionIn3;

      return ((_ref2 = (_continuousQuestionIn2 = continuousQuestionIndexes.get(a.id.toString())) !== null && _continuousQuestionIn2 !== void 0 ? _continuousQuestionIn2 : a.index) !== null && _ref2 !== void 0 ? _ref2 : 0) - ((_ref3 = (_continuousQuestionIn3 = continuousQuestionIndexes.get(b.id.toString())) !== null && _continuousQuestionIn3 !== void 0 ? _continuousQuestionIn3 : b.index) !== null && _ref3 !== void 0 ? _ref3 : 0);
    });

    if (!(matchingQuestionReleases !== null && matchingQuestionReleases !== void 0 && matchingQuestionReleases.length)) {
      return /*#__PURE__*/_jsxs("i", {
        children: ["(", label.notHaveAnyQuestionInThisSection, ")"]
      });
    }

    return matchingQuestionReleases.map(function (question) {
      var questionDisplayIndex = getQuestionDisplayIndex(question);
      var hasAnswered = answeredQuestionIds === null || answeredQuestionIds === void 0 ? void 0 : answeredQuestionIds.some(function (questionAnswered) {
        var _questionAnswered$spl = questionAnswered.split('_'),
            _questionAnswered$spl2 = _slicedToArray(_questionAnswered$spl, 3),
            _ = _questionAnswered$spl2[0],
            questionId = _questionAnswered$spl2[1],
            sectionId = _questionAnswered$spl2[2];

        return sectionId === section.id.toString() && questionId === question.id.toString();
      });

      if (question.type === QuestionType.FillInBlank) {
        return question.answers.map(function (a, aIndex) {
          var hasAnswered = answeredQuestionIds === null || answeredQuestionIds === void 0 ? void 0 : answeredQuestionIds.some(function (questionAnswered) {
            var _questionAnswered$spl3 = questionAnswered.split('_'),
                _questionAnswered$spl4 = _slicedToArray(_questionAnswered$spl3, 3),
                answerBlankId = _questionAnswered$spl4[0],
                questionId = _questionAnswered$spl4[1],
                sectionId = _questionAnswered$spl4[2];

            return sectionId === section.id.toString() && questionId === question.id.toString() && answerBlankId === a.id.toString();
          });
          return /*#__PURE__*/_jsx(QuestionItemColumn, {
            children: /*#__PURE__*/_jsx(QuestionItem, {
              onClick: function onClick() {
                onSelectQuestion(index, question.id.toString(), section.id.toString());
              },
              focus: true,
              answered: hasAnswered,
              children: questionDisplayIndex + aIndex
            })
          }, a.id.toString());
        });
      }

      if (question.type === QuestionType.Matching) {
        var matchingQuestion = question;
        return matchingQuestion.subQuestions.map(function (s, sIndex) {
          var hasAnswered = answeredQuestionIds === null || answeredQuestionIds === void 0 ? void 0 : answeredQuestionIds.some(function (questionAnswered) {
            var _questionAnswered$spl5 = questionAnswered.split('_'),
                _questionAnswered$spl6 = _slicedToArray(_questionAnswered$spl5, 3),
                subQuestionId = _questionAnswered$spl6[0],
                questionId = _questionAnswered$spl6[1],
                sectionId = _questionAnswered$spl6[2];

            return sectionId === section.id.toString() && questionId === question.id.toString() && subQuestionId === s.id.toString();
          });
          return /*#__PURE__*/_jsx(QuestionItemColumn, {
            children: /*#__PURE__*/_jsx(QuestionItem, {
              onClick: function onClick() {
                onSelectQuestion(index, question.id.toString(), section.id.toString());
              },
              focus: true,
              answered: hasAnswered,
              children: questionDisplayIndex + sIndex
            })
          }, s.id.toString());
        });
      }

      return /*#__PURE__*/_jsx(QuestionItemColumn, {
        children: /*#__PURE__*/_jsx(QuestionItem, {
          onClick: function onClick() {
            onSelectQuestion(index, question.id.toString(), section.id.toString());
          },
          focus: true,
          answered: hasAnswered,
          children: questionDisplayIndex
        })
      }, question.id.toString());
    });
  };

  var renderPanels = function renderPanels() {
    return sectionSummaries.map(function (section, index) {
      var _section$audioFile;

      var volumeIcon = currentPlayingAudioId && currentPlayingAudioId === ((_section$audioFile = section.audioFile) === null || _section$audioFile === void 0 ? void 0 : _section$audioFile.id.toString()) && /*#__PURE__*/_jsx(StyledSoundFilled, {});

      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(SectionPanel, {
          children: [/*#__PURE__*/_jsxs(StyledSectionTitle, {
            children: [/*#__PURE__*/_jsxs(StyledSectionHeader, {
              children: [/*#__PURE__*/_jsx("strong", {
                children: "".concat(label.section, " ").concat(index + 1)
              }), volumeIcon]
            }), /*#__PURE__*/_jsx(AnswerProcess, {
              children: "".concat(label.answered, " ").concat(getNumberQuestionAnswered(section), "/").concat(getTotalQuestions(questionReleases, section))
            })]
          }), /*#__PURE__*/_jsx(PanelContent, {
            gutter: 8,
            children: renderQuestionItems(section, index)
          })]
        }), /*#__PURE__*/_jsx(StyledDivider, {})]
      });
    });
  };

  if (!sectionSummaries) {
    return /*#__PURE__*/_jsx(Skeleton, {
      paragraph: {
        rows: 10
      },
      active: true
    });
  }

  return /*#__PURE__*/_jsx(_Fragment, {
    children: renderPanels()
  });
};